import { requiredLimitedPeriodSIPForTarget } from "../../engine/calculations";

const config = {
  key: "req-limited-period-sip",
  title: "Limited Period SIP Need-Based",
  category: "Target-Based",
  description: "Find the monthly SIP you need if you'll only invest for part of the time before your goal.",
  fields: [
    { key: "goalAmount", label: "Goal amount", type: "currency", default: 50_00_000, min: 1000, max: 100_00_00_000 },
    { key: "sipYears", label: "Years you'll invest (SIP period)", type: "number", default: 10, min: 1, max: 40 },
    { key: "totalYears", label: "Total years until you need the money", type: "number", default: 20, min: 1, max: 50, help: "Include the SIP years — the corpus keeps compounding after the SIP stops." },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  compute(values) {
    const goalAmount = Number(values.goalAmount) || 0;
    const sipYears = Number(values.sipYears) || 0;
    const totalYears = Number(values.totalYears) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;

    const requiredMonthlySIP = requiredLimitedPeriodSIPForTarget(goalAmount, annualRate, sipYears, totalYears);

    return {
      headline: { label: "Required Monthly SIP", value: requiredMonthlySIP },
      breakdown: [
        { label: "Goal amount", value: goalAmount },
        { label: "You invest for", value: Math.min(sipYears, totalYears), format: "text" },
        { label: "Then compounds untouched for", value: Math.max(totalYears - sipYears, 0), format: "text" },
      ],
    };
  },
};

export default config;
